import streetView from './street-view'

const report = {
    streetView: Object.assign(streetView, streetView),
}

export default report